import React from 'react'
import "./Preloader.css";

export const Preloader = () => {
  return (
    <div id="ploader">
      <div className="loader-content">
        <div className="loader"></div>
      </div>
    </div>
  )
}
